module.exports = __webpack_public_path__ + "img/Elisa_Ricci@2x.74aa63e1.png";